exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-nav-container{background:#e43a3d}.top-nav-container .logo img{width:120px;height:43px;display:inline-block;margin:24px 100px 0 0}.top-nav-container .page-nav{overflow:hidden}.top-nav-container .page-nav a{float:left;line-height:90px;width:80px;font-size:16px;color:#fff;text-align:center}.top-nav-container .page-nav a:hover:not(.nuxt-link-active){background:rgba(198,20,32,.4)}.top-nav-container .page-nav a.nuxt-link-active{background:#c61420;font-weight:700}", ""]);

// exports
